import { parseISO, addDays, format, isValid } from 'date-fns'

export interface TripDay {
  date: string // YYYY-MM-DD format
  formattedDate: string // e.g., "Friday, Nov 14"
  dayOfWeek: string // e.g., "Friday"
}

export function generateTripDays(startDate: string | null, endDate: string | null): TripDay[] {
  if (!startDate || !endDate) {
    return []
  }

  // Use parseISO to parse date-only strings without timezone issues
  const start = parseISO(startDate)
  const end = parseISO(endDate)

  // Validate dates
  if (!isValid(start) || !isValid(end)) {
    return []
  }

  // Ensure start is before or equal to end
  if (start > end) {
    return []
  }

  const days: TripDay[] = []
  let currentDate = start

  // Generate all dates from start to end (inclusive)
  while (currentDate <= end) {
    const dateString = format(currentDate, 'yyyy-MM-dd')
    const formattedDate = format(currentDate, 'EEEE, MMM d')
    const dayOfWeek = format(currentDate, 'EEEE')

    days.push({
      date: dateString,
      formattedDate,
      dayOfWeek
    })

    // Move to next day
    currentDate = addDays(currentDate, 1)
  }

  return days
}

